import { iCode } from 'models/code.model'
import api from './api'

const checkCode = async (code: string): Promise<Partial<iCode>> => {
  const { data } = await api.get<Partial<iCode>>(`/v1/codes/${code}`)
  return data
}

const useCode = async (code: string): Promise<Partial<iCode>> => {
  const { data } = await api.post<Partial<iCode>>(`/v1/codes/${code}`)
  return data
}

export default {
  checkCode,
  useCode,
}
